export default "__VITE_ASSET__DOZL0R6v__"